import { Trans } from '~/common/context';
import { Button, Flex, Modal } from '@wyz/ui';

type Props = {
  onClose: () => void;
};
const ExpressFailureModal = ({ onClose }: Props) => {
  return (
    <Modal.Container open={true} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>
          <Trans i18nKey='app.purchase.quote_search_page.express_errors.title' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Trans i18nKey='app.purchase.quote_search_page.express_errors.message' />
      </Modal.Body>
      <Modal.Footer>
        <Flex className='center space-x-2'>
          <Button
            id='close-modal'
            variant='danger'
            className='mx-2'
            onClick={onClose}
          >
            <Trans i18nKey='app.common.button.close' />
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal.Container>
  );
};

export default ExpressFailureModal;
